/* ==========================================================================
   OTF Facelift — otf-motion-scenes.js (2 Sep 2026, CEO: "apply all of this")
   The JS half of the seven approved motion scenes; the CSS half is
   otf-motion-scenes.css and the list of scenes is in its header. This file
   attaches from the OUTSIDE of fluid-motion.js: it never calls into it and
   never edits its DOM ahead of it. It watches the document for the elements
   fluid-motion.js creates and dresses them the moment they appear:

   - the tap mark (.fluid-loadmark), the page-sheet wait (.fluid-pgwait), the
     pull-to-refresh mark (.fluid-ptr) and the empty bag (.fluid-bempty) get
     the BREATHING lotus - the splash's geometry, each petal wrapped so it can
     scale from its base. fluid-motion.js draws a static marklet into them;
     the static one is swapped for the breathing one, nothing else changes.
   - when the add-to-bag flight (img.fluid-fly) lands and is removed, petals
     scatter at the bag icon and the icon jumps (.otf-bump).
   - while a product sheet (.fluid-sheet) is open, <html> carries
     .otf-sheetopen so the home can fall back beneath it; the class comes
     off the moment the sheet starts closing (it loses .opened), so the
     close morph aims at the card's true position.
   - the pull mark: fluid-motion.js drives its transform with a rotation
     (q * 300deg). The mark must not rotate, so the inner svg is counter-
     rotated by the same angle and the angle becomes --q, which opens the
     petals with the pull. The variable is written on the svg, never on the
     element being observed, so the observer cannot feed itself.
   - the redeal: when [data-redeal] swaps the six cards, the newly shown
     wraps get .otf-deal with a stagger index so they deal in one after
     another. Only on a redeal - never on first paint, which the reveal
     choreography already owns.

   Nothing here is customer-facing text. Reduced motion: no petals, no
   bump, no stagger; the breathing marks stand still (CSS).
   ========================================================================== */
(function () {
  'use strict';
  if (!window.MutationObserver) return;
  var REDUCE = matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------------- the breathing mark ---------------- */
  var SMALL = 'M50,78 C42.5,70 42,60 50,52 C58,60 57.5,70 50,78 Z';
  var MID = 'M50,78 C41.5,68 41,52 50,42 C59,52 58.5,68 50,78 Z';
  var TALL = 'M50,78 C40,66 39.5,45 50,32 C60.5,45 60,66 50,78 Z';
  var ECHO = 'M50,70 C45.5,62 45,50 50,43 C55,50 54.5,62 50,70 Z';
  /* path, rotation, closed angle, closed scale, is the echo petal */
  var PET = [
    [ECHO, 0, '0deg', '.55', true],
    [TALL, 0, '0deg', '.6', false],
    [MID, -34, '22deg', '.35', false],
    [MID, 34, '-22deg', '.35', false],
    [SMALL, -68, '44deg', '.18', false],
    [SMALL, 68, '-44deg', '.18', false]
  ];
  function breathe() {
    var s = '<svg class="marklet otfb" viewBox="0 0 100 100" fill="none" stroke="currentColor" aria-hidden="true">' +
      '<circle cx="50" cy="50" r="45.5" stroke-width="5"/>' +
      '<g transform="translate(50 52) scale(0.72) translate(-50 -61)" stroke-width="6.5" stroke-linejoin="round" stroke-linecap="round">';
    for (var i = 0; i < PET.length; i++) {
      var p = PET[i], rot = p[1] ? ' rotate(' + p[1] + ' 50 78)' : '';
      s += '<g transform="translate(50 78)"><g class="otfb-p' + (p[4] ? ' otfb-e' : '') + '" style="--c:' + p[2] + ';--s:' + p[3] + '">' +
        '<path transform="translate(-50 -78)' + rot + '" d="' + p[0] + '"' + (p[4] ? ' stroke-width="4.5"' : '') + '/></g></g>';
    }
    return s + '</g></svg>';
  }
  function swap(host) {
    if (!host || !host.querySelector) return null;
    var old = host.querySelector('svg.marklet');
    if (!old || old.classList.contains('otfb')) return old;
    var tmp = document.createElement('div');
    tmp.innerHTML = breathe();
    var fresh = tmp.firstChild;
    old.parentNode.replaceChild(fresh, old);
    return fresh;
  }

  /* ---------------- 3. petals where the flight lands ---------------- */
  var COLS = ['#e9cd88', '#b2622d', '#7a8a5e'];
  function puff(x, y) {
    if (REDUCE.matches) return;
    for (var i = 0; i < 7; i++) (function (i) {
      var p = document.createElement('i');
      p.className = 'otf-puff';
      p.style.background = COLS[i % 3];
      p.style.left = x + 'px'; p.style.top = y + 'px';
      document.body.appendChild(p);
      var ang = -Math.PI / 2 + (i - 3) * 0.42, dist = 26 + Math.random() * 16, t0 = performance.now();
      (function step(now) {
        var u = Math.min(1, (now - t0) / 520), e = 1 - Math.pow(1 - u, 2);
        p.style.transform = 'translate(' + (Math.cos(ang) * dist * e - 3) + 'px,' + (Math.sin(ang) * dist * e + u * 14 - 5) + 'px) rotate(' + (u * 160) + 'deg)';
        p.style.opacity = String(1 - u);
        if (u < 1) requestAnimationFrame(step); else p.remove();
      })(t0);
    })(i);
  }
  function landed() {
    if (REDUCE.matches) return;
    var bc = document.querySelector('.fluid-bagcount');
    if (!bc) return;
    var ico = bc.closest('.ico') || bc;
    var r = ico.getBoundingClientRect();
    if (!r.width && !r.height) return;
    puff(r.left + r.width / 2, r.top + r.height / 2);
    if (ico !== bc) {
      ico.classList.remove('otf-bump');
      void ico.offsetWidth;
      ico.classList.add('otf-bump');
      setTimeout(function () { ico.classList.remove('otf-bump'); }, 700);
    }
  }

  /* ---------------- 6. the sheet: the home falls back ---------------- */
  var root = document.documentElement;
  function sheetAdded(el) {
    root.classList.remove('otf-sheetclosing');
    root.classList.add('otf-sheetopen');
    var wasOpened = false;
    var ao = new MutationObserver(function () {
      var open = el.classList.contains('opened');
      if (open) { wasOpened = true; return; }
      if (wasOpened) {
        wasOpened = false;
        root.classList.add('otf-sheetclosing');
        root.classList.remove('otf-sheetopen');
      }
    });
    ao.observe(el, { attributes: true, attributeFilter: ['class'] });
    el._otfAo = ao;
  }
  function sheetRemoved(el) {
    if (el._otfAo) { el._otfAo.disconnect(); el._otfAo = null; }
    if (!document.querySelector('.fluid-sheet')) {
      root.classList.remove('otf-sheetopen');
      setTimeout(function () { root.classList.remove('otf-sheetclosing'); }, 400);
    }
  }

  /* ---------------- 7. the pull mark: upright, opening with the pull ---------------- */
  function ptrAdded(el) {
    var svg = swap(el);
    if (!svg) return;
    var ao = new MutationObserver(function () {
      var m = /rotate\(([-\d.]+)deg\)/.exec(el.style.transform || '');
      var d = m ? parseFloat(m[1]) : 0;
      var q = Math.max(0, Math.min(1, d / 300));
      svg.style.transform = 'rotate(' + (-d) + 'deg)';
      svg.style.setProperty('--q', q.toFixed(3));
    });
    ao.observe(el, { attributes: true, attributeFilter: ['style'] });
  }

  /* ---------------- watch the document ---------------- */
  function added(el) {
    if (el.nodeType !== 1) return;
    var c = el.classList;
    if (c.contains('fluid-loadmark')) { swap(el); return; }
    if (c.contains('fluid-ptr')) { ptrAdded(el); return; }
    if (c.contains('fluid-sheet')) { sheetAdded(el); return; }
    if (c.contains('fluid-bempty')) { if (!el.querySelector('.otfb')) el.insertAdjacentHTML('afterbegin', breathe()); return; }
    if (c.contains('fluid-pgwait')) { swap(el); return; }
    if (el.querySelector) {
      var w = el.querySelector('.fluid-pgwait'); if (w) swap(w);
      var b = el.querySelector('.fluid-bempty'); if (b && !b.querySelector('.otfb')) b.insertAdjacentHTML('afterbegin', breathe());
    }
  }
  function removed(el) {
    if (el.nodeType !== 1) return;
    var c = el.classList;
    if (c.contains('fluid-fly')) { landed(); return; }
    if (c.contains('fluid-sheet')) { sheetRemoved(el); return; }
  }
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i], j;
      for (j = 0; j < m.addedNodes.length; j++) added(m.addedNodes[j]);
      for (j = 0; j < m.removedNodes.length; j++) removed(m.removedNodes[j]);
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });

  /* anything already on the page when this runs (fluid-motion.js is deferred
     too, so normally nothing is - but the empty bag may already be rendered) */
  var pre = document.querySelectorAll('.fluid-bempty, .fluid-pgwait, .fluid-loadmark');
  for (var k = 0; k < pre.length; k++) added(pre[k]);

  /* ---------------- the redeal stagger ---------------- */
  var grid = document.querySelector('.fluid-home .fluid-grid');
  if (grid && !REDUCE.matches) {
    var armed = false;
    var go = new MutationObserver(function (muts) {
      var disarm = false, k = 0;
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i], t = m.target, old = m.oldValue || '';
        if (t === grid) {
          var has = grid.classList.contains('swapping'), had = old.indexOf('swapping') >= 0;
          if (has && !had) armed = true;
          if (!has && had) disarm = true;
          continue;
        }
        if (!armed || !t.classList || !t.classList.contains('fluid-gwrap')) continue;
        if (t.classList.contains('gon') && old.indexOf('gon') < 0) {
          t.classList.remove('otf-deal');
          void t.offsetWidth;
          t.style.setProperty('--k', String(k++));
          t.classList.add('otf-deal');
        }
      }
      if (disarm) armed = false;
    });
    go.observe(grid, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
  }
})();
